import type { HighchartsReactRefObject } from 'highcharts-react-official';

type Options = {
  width?: number;
  height?: number;
};

export function getChartSvgFromRef(ref: React.RefObject<HighchartsReactRefObject> | null, options?: Options): string {
  if (ref?.current) {
    const chart = ref.current.chart;
    const chartHTML = chart.getSVG({
      chart: {
        width: options?.width ?? 700
      },
      exporting: {
        sourceWidth: undefined,
        sourceHeight: undefined
      }
    });
    return chartHTML;
  }
  return '';
}
